module.exports = __webpack_public_path__ + "img/logoLight.24c92d8c.png";